<section class="feature-introductions-container">
  <section class="feature-introductions-heading">
    <div class="feature-introductions-title" *ngIf="title">{{ title }}</div>
    <div class="feature-introductions-close-icon" (click)="closeButtonClick()">
      <i class="pi pi-times"></i>
    </div>
  </section>
  <section class="feature-introductions-list">
    <ng-content></ng-content>
  </section>
  <section class="feature-introductions-button-container">
    <mdk-btn
      class="feature-introductions-button"
      [type]="quaternaryButton"
      [withBorder]="false"
      [buttonText]="'PARENT_PORTAL.FEATURE_INTRODUCTIONS.BUTTON' | translate"
      (buttonClick)="buttonClick()"
    />
  </section>
</section>
